import React, { useState, useEffect } from "react";

function CompAddList(props) {
  return (
    <div>
      {props.attributes.map(attr => {
        let attrName = attr.get("attr");
        let isMulti = attr.get("quant") === "n?" || attr.get("quant") === "n!";
        let noCurrent = !props.spec.get(attrName);
        let someValMandatory =
          attr.get("quant") === "n!" || attr.get("quant") === "1!";
        if (noCurrent || isMulti) {
          let addSym;
          if (isMulti) addSym = "++";
          else addSym = "+";
          if (noCurrent && someValMandatory) addSym += "!";
          let key = attrName + "ADD";
          return (
            <div
              key={key}
              onClick={e => {
                e.stopPropagation();
                props.addNew(attr);
              }}
              className="CompAddItem"
            >
              {addSym} {attr.get("name")}
            </div>
          );
        } else return "";
      })}
    </div>
  );
}
export default CompAddList;



// WEBPACK FOOTER //
// ./src/components/CompAddList.js